import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { createQuickPayContract, updateQuickPayContract, getExpiredQuickPayContracts, getQuickPayContracts, updateActiveQuickPayContract, getTermsAndConditions, } from 'utils/ContractsWebAPIUtils';
export function useQuickPayContracts(id) {
    const query = useQuery({
        queryKey: ['quickpay-active', id],
        queryFn: getQuickPayContracts,
    });
    const { data, error, isLoading, isError, isSuccess, status, isRefetching } = query;
    return { data, error, isLoading, isError, isSuccess, status, isRefetching };
}
export function useExpiredQuickPayContracts(id) {
    const query = useQuery({
        queryKey: ['quickpay-expired', id],
        queryFn: getExpiredQuickPayContracts,
    });
    const { data, error, isLoading, isError, isSuccess, status, isRefetching } = query;
    return { data, error, isLoading, isError, isSuccess, status, isRefetching };
}
export function useUpdateQuickPay(onSaveSuccess, onSaveFail) {
    const queryClient = useQueryClient({});
    const mutation = useMutation({
        mutationFn: updateQuickPayContract,
        onSuccess: async (data) => {
            await queryClient.refetchQueries('quickpay-active');
            await queryClient.refetchQueries('quickpay-expired');
            if (onSaveSuccess) {
                onSaveSuccess(data);
            }
        },
        onError: (error) => {
            if (onSaveFail) {
                onSaveFail(error);
            }
        },
    });
    return { mutation };
}
export function useCreateQuickPay(onSaveSuccess, onSaveFail) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: createQuickPayContract,
        onSuccess: async (data) => {
            await queryClient.refetchQueries('quickpay-active');
            await queryClient.refetchQueries('quickpay-expired');
            if (onSaveSuccess) {
                onSaveSuccess(data);
            }
        },
        onError: (error) => {
            if (onSaveFail) {
                onSaveFail(error);
            }
        },
    });
    return { mutation };
}
export function useUpdateActiveQuickPay(onSaveSuccess, onSaveFail) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: updateActiveQuickPayContract,
        onSuccess: async (data) => {
            await queryClient.refetchQueries('quickpay-active');
            await queryClient.refetchQueries('quickpay-expired');
            if (onSaveSuccess) {
                onSaveSuccess(data);
            }
        },
        onError: (error) => {
            if (onSaveFail) {
                onSaveFail(error);
            }
        },
    });
    return { mutation };
}
export function useTermsAndConditions() {
    const query = useQuery({
        queryKey: ['terms-condition'],
        queryFn: getTermsAndConditions,
    });
    const { data, error, isLoading, isError, isSuccess, status, isRefetching } = query;
    return { data, error, isLoading, isError, isSuccess, status, isRefetching };
}
